import { action, observable, makeObservable } from 'mobx';
import { updateRemoteResourceV3, RemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { PaymentApis } from '../../../apis/payments';
import { PaymentIndexView } from '../../../types/payments';

export class ReceiptViewState {
  code: string = null;
  payment: RemoteResourceV3<PaymentIndexView> = RemoteResourceV3.loading();

  constructor() {
    makeObservable(this, {
      code: observable,
      payment: observable,
      init: action.bound,
      reloadReceipt: action.bound,
    });
  }

  async init(code: string) {
    this.code = code;
    await this.reloadReceipt();
  }

  async reloadReceipt() {
    await updateRemoteResourceV3(
      this.payment,
      (v) => (this.payment = v),
      () => PaymentApis.show(this.code)
    );
  }
}
